"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useComponentResize = void 0;
var react_1 = require("react");
var useComponentResize = function (ref) {
    var elementRef = ref;
    var _a = (0, react_1.useState)(0), componentWidth = _a[0], setComponentWidth = _a[1];
    var _b = (0, react_1.useState)(0), componentHeight = _b[0], setComponentHeight = _b[1];
    var updateContainerSize = function () {
        if (elementRef.current) {
            var _a = elementRef.current, offsetWidth = _a.offsetWidth, offsetHeight = _a.offsetHeight;
            setComponentWidth(offsetWidth);
            setComponentHeight(offsetHeight);
        }
    };
    (0, react_1.useEffect)(function () {
        updateContainerSize();
        var resizeObserver = new ResizeObserver(updateContainerSize);
        try {
            if (elementRef.current) {
                resizeObserver.observe(elementRef.current);
            }
        }
        catch (error) {
            console.error('Error observing resize:', error.message);
        }
        var mutationObserver = new MutationObserver(updateContainerSize);
        try {
            if (elementRef.current) {
                mutationObserver.observe(elementRef.current, {
                    attributes: true,
                    attributeFilter: ['style', 'class'],
                });
            }
        }
        catch (error) {
            console.error('Error observing mutations:', error.message);
        }
        var handleWindowResize = function () { return updateContainerSize(); };
        window.addEventListener('resize', handleWindowResize);
        return function () {
            resizeObserver.disconnect();
            mutationObserver.disconnect();
            window.removeEventListener('resize', handleWindowResize);
        };
    }, [elementRef]);
    return { componentWidth: componentWidth, componentHeight: componentHeight };
};
exports.useComponentResize = useComponentResize;
